// extracted by mini-css-extract-plugin
export default {"main_container":"ButtonArrowBack_main_container__fJunG","arrow":"ButtonArrowBack_arrow__aN0dh","clickable":"ButtonArrowBack_clickable__hJtzD"};